import styled from 'styled-components'

export const InputContainer = styled.div`
  margin-top: 20px;
`
